/**
 * Tenant Client Re-export for Identity Module
 * 
 * The identity module uses the same Supabase client as the main platform.
 * This file provides compatibility with imports from tenantClient.
 */

// Re-export the client
export { supabase } from './client';

/**
 * Get tenant headers for edge function calls.
 * In the identity module, we don't have tenant context, so return empty headers.
 */
export function getTenantHeaders(): Record<string, string> {
  return {};
}

/**
 * Get the tenant client (same as supabase for identity module)
 */
export { supabase as getTenantClient } from './client';
